import { Space } from "antd"
import cls from "classname"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"

import Button from "../Button"

export const AlertsTypeToggle = ({ value, disabled, onChange }) => {
  const isMobile = useSelector((state) => state.nav.isMobile)
  const { t } = useTranslation()

  const onChangeHandler = (value) => onChange({ alertsType: value })

  return (
    <Space.Compact size={"large"}>
      <Button
        className={cls("compact-btn", { active: value === "volume" })}
        style={{ width: isMobile && "50%" }}
        onClick={() => onChangeHandler("volume")}
        disabled={disabled}
      >
        {t("Volume")}
      </Button>
      <Button
        className={cls("compact-btn", { active: value === "count" })}
        style={{ width: isMobile && "50%" }}
        onClick={() => onChangeHandler("count")}
        disabled={disabled}
      >
        {t("Count")}
      </Button>
    </Space.Compact>
  )
}
